var _rect, _rect2, _text, _text2, _text3, _text4, _rect3, _text5, _text6, _rect4, _text7, _text8, _rect5, _text9, _text10, _rect6, _text11, _text12, _rect7, _text13, _text14, _rect8, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _rect9, _text22, _rect10, _text23, _rect11, _text24, _rect12, _text25, _rect13, _text26, _rect14, _text27, _rect15, _text28, _rect16, _text29, _rect17, _text30, _rect18, _text31, _text32, _text33, _text34, _rect19, _text35, _text36, _rect20, _text37, _text38, _rect21, _rect22, _text39, _text40, _text41, _rect23, _text42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualReturnsSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 700",
    fontFamily: "'Segoe UI', Roboto, Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 700,
    fill: "#eef2f7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 880,
    height: 636,
    rx: 14,
    fill: "#ffffff",
    stroke: "#e2e8f0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 84,
    fontSize: 24,
    fontWeight: 700,
    fill: "#0f172a"
  }, "Create manual return")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 108,
    fontSize: 13,
    fill: "#64748b"
  }, "Match the items to a nonprofit, then create a shipping label or schedule a pickup.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 148,
    fontSize: 14,
    fontWeight: 700,
    fill: "#313bac"
  }, "Customer")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 170,
    fontSize: 11,
    fill: "#64748b"
  }, "Name")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 176,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 199,
    fontSize: 14,
    fill: "#0f172a"
  }, "Jordan Ellis")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 170,
    fontSize: 11,
    fill: "#64748b"
  }, "Email")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 176,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 366,
    y: 199,
    fontSize: 14,
    fill: "#0f172a"
  }, "jordan.ellis@example.com")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 632,
    y: 170,
    fontSize: 11,
    fill: "#64748b"
  }, "Phone")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 176,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 199,
    fontSize: 14,
    fill: "#0f172a"
  }, "(555) 010-0142")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 236,
    fontSize: 11,
    fill: "#64748b"
  }, "Street address")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 242,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 265,
    fontSize: 14,
    fill: "#0f172a"
  }, "123 Market Street")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 236,
    fontSize: 11,
    fill: "#64748b"
  }, "City")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 242,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 366,
    y: 265,
    fontSize: 14,
    fill: "#0f172a"
  }, "Austin")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 632,
    y: 236,
    fontSize: 11,
    fill: "#64748b"
  }, "State and ZIP")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 632,
    y: 242,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 265,
    fontSize: 14,
    fill: "#0f172a"
  }, "TX  78701")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 318,
    fontSize: 14,
    fontWeight: 700,
    fill: "#313bac"
  }, "Items")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 340,
    fontSize: 11,
    fill: "#64748b"
  }, "Item")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 340,
    fontSize: 11,
    fill: "#64748b"
  }, "Category")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 340,
    fontSize: 11,
    fill: "#64748b"
  }, "Qty")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 588,
    y: 340,
    fontSize: 11,
    fill: "#64748b"
  }, "Value")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 340,
    fontSize: 11,
    fill: "#64748b"
  }, "Weight")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 240,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 369,
    fontSize: 14,
    fill: "#0f172a"
  }, "Linen shirt")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 346,
    width: 170,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 369,
    fontSize: 14,
    fill: "#0f172a"
  }, "Apparel")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 346,
    width: 70,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 369,
    fontSize: 14,
    fill: "#0f172a"
  }, "2")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 346,
    width: 110,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 602,
    y: 369,
    fontSize: 14,
    fill: "#0f172a"
  }, "$48.00")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 346,
    width: 110,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 369,
    fontSize: 14,
    fill: "#0f172a"
  }, "1.2 lb")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 392,
    width: 240,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 415,
    fontSize: 14,
    fill: "#0f172a"
  }, "Rain jacket")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 392,
    width: 170,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 338,
    y: 415,
    fontSize: 14,
    fill: "#0f172a"
  }, "Outerwear")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 506,
    y: 392,
    width: 70,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 415,
    fontSize: 14,
    fill: "#0f172a"
  }, "1")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 392,
    width: 110,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 602,
    y: 415,
    fontSize: 14,
    fill: "#0f172a"
  }, "$89.00")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 392,
    width: 110,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 415,
    fontSize: 14,
    fill: "#0f172a"
  }, "2.4 lb")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 456,
    fontSize: 13,
    fontWeight: 600,
    fill: "#313bac"
  }, "+ Add item")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 888,
    y: 456,
    fontSize: 13,
    textAnchor: "end",
    fill: "#15803d"
  }, "Total weight 4.8 lb of the 70 lb shipping limit")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 500,
    fontSize: 11,
    fill: "#64748b"
  }, "RMA ID")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 506,
    width: 256,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 529,
    fontSize: 14,
    fill: "#0f172a"
  }, "RMA-10428")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 500,
    fontSize: 11,
    fill: "#64748b"
  }, "Return reason")), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 506,
    width: 536,
    height: 36,
    rx: 8,
    fill: "#f8fafc",
    stroke: "#cbd5e1"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 366,
    y: 529,
    fontSize: 14,
    fill: "#0f172a"
  }, "Wrong size")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 578,
    fontSize: 11,
    fill: "#64748b"
  }, "Return method")), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 584,
    width: 300,
    height: 40,
    rx: 10,
    fill: "#eef2f7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 588,
    width: 146,
    height: 32,
    rx: 7,
    fill: "#ffffff",
    stroke: "#313bac",
    strokeWidth: 1.5
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 149,
    y: 609,
    fontSize: 13,
    fontWeight: 600,
    textAnchor: "middle",
    fill: "#313bac"
  }, "Print label")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 297,
    y: 609,
    fontSize: 13,
    textAnchor: "middle",
    fill: "#64748b"
  }, "Schedule pickup")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 392,
    y: 609,
    fontSize: 12,
    fill: "#64748b"
  }, "Label through EasyPost. Pickup through FedEx.")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 728,
    y: 584,
    width: 160,
    height: 40,
    rx: 9,
    fill: "#313bac"
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 808,
    y: 609,
    fontSize: 14,
    fontWeight: 600,
    textAnchor: "middle",
    fill: "#ffffff"
  }, "Create return")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualReturnsSample);
export default __webpack_public_path__ + "static/media/manual-returns-sample.9cd9bef3334fa311caa4def68f1f8943.svg";
export { ForwardRef as ReactComponent };